<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V36C40 38.2091 38.2091 40 36 40H4C1.79086 40 0 38.2091 0 36V4Z"
      fill="#BEF975"
      fill-opacity="0.15"
    />
    <path
      d="M25.7236 17.1924L25.9941 17.6475H25.999L30.8438 16.2559L34 18.6387L31.9287 18.084L27.8184 20.6592L27.8203 20.6611L33.1475 29.5H27.9062L27.7949 25.0488L26.2793 29.5L23.6777 26.3623C24.9523 24.6803 26.6874 22.2707 27.6865 20.7432C27.6874 20.7418 27.6876 20.7397 27.6885 20.7383L27.6826 20.7432L26.1455 21.707V21.7021L22.0801 24.4443L18.7168 26.7129L14.5908 29.499H6L10.1035 22.5391H20.4697L18.3115 19.9385L18.3379 19.9336L17.9502 19.4658L22.541 18.5107L16.6758 17.9287L13.0752 13.5918L21.4863 15.8018L10.5869 10.5H21.6885L25.7236 17.1924Z"
      fill="#BEF975"
    />
  </svg>
</template>
